export default __webpack_public_path__ + "static/media/My-Attendance-Icon.dac15599.png";